import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import BreadcrumbsContainer from "./BreadcrumbsContainer";
import getBreadcrumbsByTemplate from "./getBreadcrumbsByTemplate";
import BreadcrumbItem from "./BreadcrumbItem";
import BreadcrumbIcon from "./BreadcrumbIcon";
import "./Breadcrumbs.scss";

export const Breadcrumbs = ({ settings }) => {
  const { shop, template, section } = settings;
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const templateName = template.name;
  const backToCategory = section.use_back_to_category_products;

  return (
      <BreadcrumbsContainer isMobile={isMobile}>
        {!backToCategory && <BreadcrumbItem title="Home" url={shop.url} position={1} />}
        {(templateName !== "index" && !backToCategory) && <BreadcrumbIcon settings={settings} isMobile={isMobile} />}
        {getBreadcrumbsByTemplate(templateName, settings)}
      </BreadcrumbsContainer>
  );
};
